<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Attacher dossiers à la campagne {{ libelle }}</strong>
      </b-card-header>
      <b-card-body>
        <v-server-table @loaded="onLoaded" ref="unattached_dossiers_table" :columns="columns" :url="url" :options="options"
                        style="overflow: hidden;">
          <div slot="source" slot-scope="props">
            <b>{{ props.row.id }}</b> <br> {{ props.row.canal.libelle }}
          </div>
          <div slot="date_reception" slot-scope="props" v-html="formatDate(props.row.date_reception)">
          </div>
          <div slot="dossier_type" slot-scope="props">
            <span>{{ props.row.type ? props.row.type.libelle : 'n.d' }}</span><br>
            <span v-b-tooltip.hover
                  :title="getLibelleTraitement(props.row, 'long', traitementId)" :style="getFontColor(props.row, traitementId)">{{ getLibelleTraitement(props.row, 'court', traitementId) }}
              <!--<img class="pull-right" :src="getIconSrc('corner')">-->
            </span>
          </div>
          <div slot="siren" slot-scope="props">
            <!-- <b style="color: rgb(217, 65, 139);">{{ props.row.siren ? props.row.siren.siren : 'n.d'
              }} (OAG {{props.row.oag }} OAP {{props.row.oap }})</b><br> -->
              <b style="color: rgb(217, 65, 139);">{{ props.row.siren ? props.row.siren.siren : 'n.d' }} (OAG </b><b style="color: #ff0032;">{{ props.row.oag }}</b>
              <b style="color: rgb(217, 65, 139);">  OAP</b><b style="color: #ffa434;"> {{ props.row.oap }}</b><b style="color: rgb(217, 65, 139);">)</b><br>
            <span class="text-success"
                  :id="`tooltip-rs-${props.row.id}`">{{ props.row.siren ? (props.row.siren.raison_sociale.length > 42 ? props.row.siren.raison_sociale.substring(0, 39) + '...' : props.row.siren.raison_sociale) : 'n.d'
              }}</span>
            <b-tooltip v-if="props.row.siren && props.row.siren.raison_sociale.length > 45"
                       :target="`tooltip-rs-${props.row.id}`" triggers="hover" placement="top">
              {{ props.row.siren.raison_sociale }}
            </b-tooltip>
          </div>
          <div slot="produit" slot-scope="props" v-html="getInfosSegmentProduit(props.row)">
          </div>
          <div slot="nom" slot-scope="props">
            <b style="color: #990000;">{{ props.row.nir ? formatNir(props.row.nir) : 'n.d' }}</b> ({{ props.row.id_pp }})<br>
            <span class="">{{ props.row.nom ? props.row.nom.toUpperCase() + ' ' + props.row.prenom : 'n.d' }}</span>
          </div>
          <div slot="status" slot-scope="props" v-html="getInfosStatus(props.row, traitementId)"></div>
          <div slot="selection" slot-scope="props">
            <b-form-checkbox v-model="selectedRows" :value="props.row.id"
                             :state="errors.checkbox === ''"></b-form-checkbox>
          </div>
          <div slot="h__selection">
            <b-form-checkbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="items"
              aria-controls="items"
              @change="toggleAll">
            </b-form-checkbox>
          </div>
        </v-server-table>
        <div slot="afterTable">
          <div style="margin-bottom: 10px; justify-content: space-between;">
            <b-button type="button" @click="lancerRattachement()" class="pull-right ml-1 mr-1 mt-1" size="md" variant="primary">
              Attacher
            </b-button>
            <b-button type="button" @click="returnToDetailPage()" class="pull-left ml-1 mr-1 mt-1" size="md" variant="primary">
              Retour campagne
            </b-button>
          </div>
          <span class="field-error inline mr-1 float-right">{{ errors.checkbox }}</span>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import itemList from "@/components/SortListItem";
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import dossier_form_mixin from "../../../mixins/dossier-form-mixin";
  import controle_dossier_mixin from "../../../mixins/controle-dossier-mixin";

  export default {
    name: "AttachDossiers",
    mixins: [dossier_form_mixin, controle_dossier_mixin],
    components: {
      Multiselect,
      itemList
    },
    data() {
      let self = this;
      return {
        noSearch: 'noSearch',
        id: '',
        libelle: 'test',
        options: {
          headings: {
            'source': 'N° dossier\nCanal récept.',
            'date_reception': 'Date de\nréception',
            'dossier_type': 'Type dossier\nTraitement',
            'siren': 'SIREN\nRaison Sociale',
            'produit': 'Segment\nProduit',
            'nom': 'NIR\nNom Prénom',
            'nb_pj': 'Nb. pj\nIndication',
            'status': 'Statut\nSous-statut',
            'gestionnaire': 'Affectation',
            'delai': 'Délai\nAlerte',
            'notes': 'Notes',
            'action': '#',
            'selection': ''
          },
          columnsClasses: {
            nb_pj: 'pre-formatted tooltip-cell position-r',
            dossier_type: 'pre-formatted tooltip-cell sort-top position-r',
            siren: 'pre-formatted sort-top position-r',
            produit: 'pre-formatted sort-bottom position-r',
            nom: 'pre-formatted sort-bottom min-width-nir position-r',
            gestionnaire: 'pre-formatted position-r',
            delai: 'pre-formatted position-r',
            status: 'pre-formatted position-r',
            source: 'pre-formatted sort-top position-r',
            date_reception: 'pre-formatted align-middle sort-middle position-r',
            action: 'align-middle action-xs text-center position-r',
            selection: 'align-middle text-center position-r',
            notes: 'align-middle action-xs position-r'
          },
          rowClassCallback(row) {
            return 'row_dossier_' + row.id;
          },
          sortable: ['source', 'date_reception', 'dossier_type', 'siren', 'produit', 'nom', 'notes', 'gestionnaire'],
          filterable: false,
          resizableColumns: true,
          perPage: 10,
          perPageValues: [10, 25, 50, 75, 100],
          orderBy: {column: 'date_reception', ascending: true},
          requestFunction: function (data) {
            self.url = '/espaceQualite/campagnes/unAttachedDossiers/' + self.$route.params.id;
            if (self.noSearch !== 'noSearch') {
              self.$store.commit('IS_LOADING', true);
            }
            return axios.get(self.url, {
              params: data
            })
              .then(function (response) {
                if (self.noSearch !== 'noSearch') {
                  self.$store.commit('IS_LOADING', false);
                }
                self.findDossiers = response.data.data;
                self.searchData = data;
                return response;
              })
              .catch(function (e) {
                self.$store.commit('IS_LOADING', false);
                self.$swal({
                  position: 'top',
                  type: 'error',
                  title: 'Attention !!',
                  text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                  showConfirmButton: false,
                  timer: 5000
                });
              }.bind(this));
          },
        },
        columns: ['source', 'date_reception', 'dossier_type', 'siren', 'produit', 'nom', 'status', 'selection'],
        items: [],
        url: '',
        allSelected: [],
        selectedRows: [],
        indeterminate: false,
        errors: {
          checkbox: ''
        },
        traitementId: ''
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + ' ' + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.id = this.$route.params.id;
      this.noSearch = 'search';
      this.getCampagneLibelle();
    },
    methods: {
      getCampagneLibelle() {
        let self = this;
        // this.$store.commit('IS_LOADING', true);
        this.$axios
          .get("/espaceQualite/campagnes/details/" + this.id)
          .then(response => {
            this.libelle = response.data.campagne.libelle;
            this.traitementId = response.data.campagne.traitement_id;
            // this.$store.commit('IS_LOADING', false);
          })
          .catch((error) => {
            // this.$store.commit('IS_LOADING', false);
            if (error.response && error.response.status === 404 && self != undefined) {
              this.displayWarningModal(`La campagne avec l'id ${this.id} n'existe pas`);
              this.$router.push({path: '/espace-qualite/campagnes'})
            }
          });
      },
      onLoaded() {
        // this.$store.commit("IS_LOADING", false);
      },
      toggleAll(checked) {
        this.selectedRows = checked ? this.$refs['unattached_dossiers_table'].data.map(item => {
          return item.id
        }) : []
      },
      lancerRattachement() {
        if (this.validateCheckedCheckbox()) {
          this.$store.commit("IS_LOADING", true);
          const uniqueRows = [...new Set(this.selectedRows)];
          this.$axios
            .post("/espaceQualite/campagnes/attachDossiers/" + this.id, {'dossiers' : uniqueRows})
            .then((result) => {
              this.$store.commit("IS_LOADING", false);
              this.$refs['unattached_dossiers_table'].refresh();
              this.$swal({
                position: "top",
                type: "success",
                title: "Attachement avec succès",
                text: "Les dossiers ont été bien attachés",
                showConfirmButton: false,
                timer: 4000
              });
            })
            .catch((error) => {
              let errorText = "";
              this.$store.commit("IS_LOADING", false);
              if (error.response && error.response.status === 406) {
                errorText = error.response.data.message;
              } else {
                errorText = "Une erreur est survenue, lors de l'attachement des dossiers. Si le problème persiste, merci de faire un ticket au support DOSI.";
              }
              this.displayErrorModal(errorText);
            });
        } else {
          this.displayWarningModal("Vous devez d'abord sélectionner un ou plusieurs dossiers avant de pouvoir faire un attachement");
        }
      },
      validateCheckedCheckbox() {
        let error = false;
        this.errors.checkbox = '';
        if (this.selectedRows.length === 0) {
          error = true;
          this.errors.checkbox = 'Vous devez choisir au moins un dossier.';
        }
        return !error
      },
      returnToDetailPage() {
        this.$router.push({path: '/espace-qualite/campagnes/detail/' + this.id});
      }
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
